(function () {
  "use strict";

  function parseHolidays(str) {
    if (!str) return [];
    return str
      .split(",")
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function isHoliday(date, holidays) {
    var iso = date.toISOString().slice(0, 10); // YYYY-MM-DD
    return holidays.indexOf(iso) !== -1;
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6; // Sun = 0, Sat = 6
  }

  function addBusinessDays(startDate, days, holidays) {
    var result = new Date(startDate.getTime());
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result) && !isHoliday(result, holidays)) {
        added++;
      }
    }
    return result;
  }

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th"; // covers 11th-13th
    switch (day % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function formatDateShort(date) {
    var months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    var day = date.getDate();
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    var suffix = getOrdinalSuffix(day);

    return month + " " + day + suffix + ", " + year;
  }

  function init(el) {
    var minDays = parseInt(el.getAttribute("data-min-days"), 10) || 3;
    var holidays = parseHolidays(el.getAttribute("data-holidays"));
    var messageEl = el.querySelector("[data-delivery-message]");

    if (!messageEl) return;

    var now = new Date();
    var earliest = addBusinessDays(now, minDays, holidays);

    var html = "<img style='width: 22px' src='https://cdn.shopify.com/s/files/1/0768/3198/1717/files/flag_1.png?v=1788854053'/> Delivered by <strong>(" + formatDateShort(earliest) + ")</strong>";

    messageEl.innerHTML = html;
  }

  function initAll() {
    var widgets = document.querySelectorAll("[data-delivery-estimate]");
    widgets.forEach ? widgets.forEach(init) : Array.prototype.forEach.call(widgets, init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();